import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getGoalQueryKey } from "modules/campaigns/lib/goals/goalQuery"
import { CreateGoalSchema, GoalResponseDataSchema } from "schema"
import { z } from "zod"

export const useUpdateGoalMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      id,
      payload,
    }: {
      id: string
      payload: z.infer<typeof CreateGoalSchema>
    }) => {
      const { data } = await axios.put<{ data: z.infer<typeof GoalResponseDataSchema> }>(
        `/goals/${id}`,
        payload,
      )

      queryClient.setQueryData(getGoalQueryKey(id), () => data.data)

      return data.data
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === "goals",
      })
      queryClient.invalidateQueries({ queryKey: getGoalQueryKey(variables.id) })
    },
  })
}
